import React, { useEffect, useState } from "react";
import { NavLink, Link, useNavigate } from "react-router";
import { motion, useScroll, useTransform } from "framer-motion";
import { User, ChevronDown, UserPen } from "lucide-react";
import { useSelector, useDispatch } from "react-redux";
import { setOpenSheet, setOpenBookNow } from "../redux/slices/sheetSlice";
import Logo from "../assets/images/logo.png";
import whatsApp from "../assets/images/whatsapp.png";
import LogoutBtn from "../assets/images/logout.svg"
import BookNowIcon from "./BookNowIcon";
import { clearCustomer } from '../redux/slices/customerSlice';

const DesktopHeader = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const customer = useSelector((state) => state.customer.customer);

  const initials = `${customer?.firstName?.charAt(0) || ""}${
    customer?.lastName?.charAt(0) || ""
  }`.toUpperCase();

  const { scrollY } = useScroll();
  const bgOpacity = useTransform(scrollY, [0, 100], [0, 1]);
  const bgColor = useTransform(bgOpacity, (o) => `rgba(255, 255, 255, ${o})`);
  const boxShadow = useTransform(
    bgOpacity,
    (o) => `0 2px 10px rgba(0,0,0,${o * 0.1})`
  );

  const [visible, setVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY) {
        // scrolling down
        setVisible(false);
      } else {
        // scrolling up
        setVisible(true);
      }
      setLastScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  const goToBookNowPage = () => {
     //data layer
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
          event: "header_book_now_btn_click",
          event_type:"book_now_popup_open"
      });
    dispatch(setOpenBookNow(true));
  };

  const logOutCustomer = ()=>{
    dispatch(clearCustomer(customer));
  }

  return (
    <motion.section
      id="navbar"
      className="header sticky-header"
      style={{
        position: "sticky",
        top: 0,
        zIndex: 3,
        backgroundColor: bgColor,
        boxShadow: boxShadow,
        backdropFilter: "blur(10px)",
        y: visible ? 0 : -110,
        transition: "transform 0.3s ease",
      }}
    >
      <div className="navigation">
        <div className="section-logo">
          <Link to="/">
            <img src={Logo} alt="pressto" width="170px" height="37px" />
          </Link>
        </div>
        <div className="section-nav">
          <nav>
            <ul>
              <li>
                <NavLink to="/" end>
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink to="/about" end>
                  About Us
                </NavLink>
              </li>
              <li>
                <NavLink to="/store" end>
                  Stores
                </NavLink>
              </li>
              <li>
                <span>Services</span>
                <ChevronDown />
                <ul className="nav-dropdown">
                  <li>
                    <NavLink to="/service/dry-cleaning" end>
                      Drycleaning & Laundry
                    </NavLink>
                  </li>
                  <li className="divider">
                    <span></span>
                  </li>
                  <li>
                    <NavLink to="/service/shoes-and-bag-care" end>
                      Shoe & Bag Care
                    </NavLink>
                  </li>
                </ul>
              </li>
              <li>
                <NavLink to="/blog" end>
                  Blog
                </NavLink>
              </li>
              <li>
                <NavLink to="/contact" end>
                  Contact Us
                </NavLink>
              </li>
            </ul>
          </nav>
        </div>
        <div className="section-contact">
          {customer ? (
            <div className="user-dropdown">
              <div className="user-icon">
                {initials}
              </div>
                <ul className="nav-dropdown">
                  <li>
                    <NavLink to="/profile" end>
                      <UserPen size={16} /> <span style={{marginLeft:"8px"}}>My Account</span>
                    </NavLink>
                  </li>
                  <li className="divider">
                    <span></span>
                  </li>
                  <li onClick={logOutCustomer}>
                   <img src={LogoutBtn} alt="logout"/> <span style={{marginLeft:"8px"}}>Logout</span>
                  </li>
                </ul>
            </div>
          ) : (
            <div className="user-dropdown">
              <div
                className="user-icon"
                onClick={() => dispatch(setOpenSheet(true))}
              >
                <User size={18} />
              </div>
            </div>
          )}

          <div
            className="user-icon"
            onClick={() => {
              const phone = "911800229199";
              const message = encodeURIComponent("Let's Start!");
              const url = `https://api.whatsapp.com/send?phone=${phone}&text=${message}`;
              window.open(url, "_blank");
            }}
            style={{ cursor: "pointer" }}
          >
            <img src={whatsApp} alt="whatsapp" />
          </div>
          <div
            className="btn btn-md base-btn secondary"
            onClick={goToBookNowPage}
          >
            Schedule Pickup
            <div className="icon-box">
              <BookNowIcon />
            </div>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default DesktopHeader;
